var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"h-full w-full"},[_c('el-main',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"正在生成合同预览，请稍候","element-loading-spinner":"el-icon-loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }